import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCheck, Clock } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { API_URL, fmtTime } from './chatShared';

export const AcksDialog = ({ msg, onClose }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (!msg) return;
    setRows(null);
    axios.get(`${API_URL}/chat/messages/${msg.id}/acks`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [msg]);
  const read = (rows || []).filter((r) => r.read_at);
  const unread = (rows || []).filter((r) => !r.read_at);
  return (
    <Dialog open={!!msg} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="chat-acks-dialog" aria-describedby={undefined}>
        <DialogHeader><DialogTitle>Confirmações de leitura</DialogTitle></DialogHeader>
        {!rows ? <p className="text-sm text-slate-400">A carregar…</p> : (
          <div className="max-h-80 overflow-y-auto space-y-3 text-sm">
            <div data-testid="chat-acks-unread">
              <p className="text-xs font-semibold text-rose-700 mb-1">Ainda não leram ({unread.length})</p>
              {unread.map((r) => <p key={r.id} className="flex items-center gap-1.5 py-0.5"><Clock className="w-3.5 h-3.5 text-rose-500" />{r.name}</p>)}
            </div>
            <div data-testid="chat-acks-read">
              <p className="text-xs font-semibold text-emerald-700 mb-1">Confirmaram ({read.length})</p>
              {read.map((r) => <p key={r.id} className="flex items-center gap-1.5 py-0.5"><CheckCheck className="w-3.5 h-3.5 text-emerald-600" />{r.name}<span className="ml-auto text-xs text-slate-400">{fmtTime(r.read_at)}</span></p>)}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
